import { Alert, AlertIcon, AlertTitle, Badge, Button, Tooltip } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { BlindsClosed, DeleteForeverSharp, RestorePageRounded } from '@mui/icons-material';
import {
  AppBar,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Slide,
  Switch,
  Toolbar,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import InputField from 'components/fields/InputField';
import FormSkeleton from 'components/FormSkeleton';
import MButton from 'components/Mbutton';
import Error from 'components/message/Error';
import MMenus from 'components/MMenus';
import MuiAsyncAutocomplete from 'components/MuiAsyncAutocomplete';
import MuiAUtocomplete from 'components/MuiAutocomplete';
import MuiCollapse from 'components/MuiCollapse';
import MuiSelect from 'components/MuiSelect';
import PDFViewer from 'components/PDFViewer';
import PreloaderSpinner from 'components/PreloaderSpinner';
import CheckAuthorization from 'components/security/CheckAutorization';
import { CloseModalButton } from 'components/Utils';
import { ENTERPRISE_STATUS, ROLES_LIST } from 'Constaints';
import useDataFetching from 'hooks/useDataFetching';
import usePostAxiosData from 'hooks/usePostAxiosData';
import React, { useEffect, useState } from 'react';
import { useAuthUser } from 'react-auth-kit';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import {
  BsBan,
  BsCarFront,
  BsEnvelopeExclamation,
  BsGeoAlt,
  BsIntersect,
  BsListTask,
  BsPencilSquare,
  BsPeople,
  BsSearch,
} from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { createMapLink, formatDate, formatDateTime, getImageUrlAPI } from 'utils';
import { config } from 'variables/config';
import * as yup from 'yup';
import EmployesByEnterpriseModal from '../employes/EmployesByEnterpriseModal';
import AssignEnterpriseToMission from '../Missions/AssignEnterpriseToMission';
import AssignEnterpriseTotask from '../Tasks/AssignEnterpriseTotask';
import ImageGallery from './ImageGallery';
import MergeEnterprises from './MergeEnterprises';
import Notify from './Notify';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddEnterprise({
  open,
  handleClose,
  handleCloseOnly,
  selectedEnterpriseP,
  get,
}) {
  const { t } = useTranslation('add_enterprise');
  const [selectedEnterprise, setSelectedEnterprise] = useState(null);
  const [loadingEN, errorEn, resleutEn, fetchEnterprise] = useDataFetching(
    selectedEnterpriseP?.id ? `${config.app.api_url}/enterprises/${selectedEnterpriseP?.id}` : null
  );
  useEffect(() => {
    resleutEn && setSelectedEnterprise(resleutEn?.data);
  }, [resleutEn]);

  const navigate = useNavigate();
  const [openAss, setOpenAss] = useState(false);
  const [openAssTask, setOpenAsstask] = useState(false);
  const [openMerge, setOpenMerge] = useState(false);
  const [openNotify, setOpenNotify] = useState(false);
  const auth = useAuthUser();
  const [canEdit, setCanEdit] = useState(false);
  const [region, setRegion] = useState(null);
  const [departement, setDepartement] = useState(null);
  const [arrondissement, setArrondissement] = useState(null);
  const [zone, setZone] = useState(null);
  const [sector, setSector] = useState([]);
  const [selectedRepports, setSelectedRepports] = useState([]);
  const [spotting, setSpotting] = useState(selectedEnterprise?.spotting);
  const [mainOffice, setMainOffice] = useState(true);
  const [fromArchive, setFromArchive] = useState(selectedEnterprise?.fromArchive);
  const [relatedMainOffice, setrelatedMainOffice] = useState(null);
  const handleChange = (event) => {
    const newOptions = Array.from(event.target.selectedOptions, (option) => option.value);
    setSector(newOptions);
  };
  const [loadingS, errorS, sectors, fetchDataS] = useDataFetching(
    `${config.app.api_url}/activity-sectors`
  );
  const [loadingR, errorR, regions, fetchDataR] = useDataFetching(`${config.app.api_url}/regions`);
  const [loadingD, errorD, departments, fetchDataD] = useDataFetching(
    region ? `${config.app.api_url}/regions/${region}/departments` : null
  );
  const [loadingA, errorA, arrondissements, fetchDataA] = useDataFetching(
    departement ? `${config.app.api_url}/departments/${departement}/arrondissements` : null
  );
  const [loadingZ, errorZ, zones, fetchZones] = useDataFetching(
    departement ? `${config.app.api_url}/departments/${departement}/zones` : null
  );
  const [loadingRe, errorRe, repports, getRepports] = useDataFetching(
    `${config.app.api_url}/reports/doc?` +
      (region ? `regionId=${region}&` : '') +
      (departement ? `departmentId=${departement}&` : '') +
      (arrondissement ? `arrondissementId=${arrondissement}` : '')
  );
  const [loadingM, errorM, modifications, fetcModifs] = useDataFetching(
    selectedEnterprise?.id
      ? `${config.app.api_url}/enterprises/${selectedEnterprise?.id}/modifications`
      : null
  );
  const [loadingRelated, errorRelated, relateds, fetcRelated] = useDataFetching(
    selectedEnterprise?.id
      ? `${config.app.api_url}/enterprises/${selectedEnterprise?.id}/related${selectedEnterprise?.relatedMainOffice ? '?mainEnterpriseId=' + selectedEnterprise?.relatedMainOffice?.id : ''}`
      : null
  );
  useEffect(() => {}, [region, departement]);

  const schema = yup.object().shape({
    socialRaison: yup.string().required(t('error_required_field')),
    sigle: yup.string(),
    locality: yup.string(),
    postal: yup.string(),
    nui: yup.string(),
    email: yup.string().email(),
    phone: yup.string(),
    website: yup.string(),
    employersNumber: yup.string(),
    RHName: yup.string(),
    RHEmail: yup.string().email(),
    RHPhone: yup.string(),
    RHPhoneWh: yup.string(),
    street: yup.string(),
    longitude: yup.string(),
    latitude: yup.string(),
    searchLongitude: yup.string(),
    files: yup.mixed().optional(),
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = (data) => {
    handleSave(data);
  };

  const [loading, postAxiosData, errorMassage, successMessage, result] = usePostAxiosData(
    `enterprises${selectedEnterprise ? '' : '/with-images'}`,
    'POST',
    true,
    selectedEnterprise ? null : 'multipart/form-data'
  );

  useEffect(() => {
    loading && setCanEdit(false);
  }, [loading]);

  const handleSave = async (dataYup) => {
    const data = {
      id: selectedEnterprise?.id || null,
      creatorId: selectedEnterprise?.id ? null : auth()?.user?.id,
      editorId: auth()?.user?.id,
      socialRaison: dataYup?.socialRaison?.toUpperCase(),
      employersNumber: dataYup?.employersNumber,
      sigle: dataYup?.sigle?.toUpperCase(),
      locality: dataYup?.locality,
      street: dataYup?.street,
      nui: dataYup?.nui,
      email: dataYup?.email,
      phone: dataYup?.phone,
      rhname: dataYup?.RHName,
      rhemail: dataYup?.RHEmail,
      rhphone: dataYup?.RHPhone,
      rhphonewh: dataYup?.RHPhoneWh,
      postal: dataYup?.postal,
      regionId: region ? parseInt(region) : null,
      departmentId: departement ? parseInt(departement) : null,
      arrondissementId: arrondissement ? parseInt(arrondissement) : null,
      zoneId: zone ? parseInt(zone) : null,
      activitySectors: sector?.map((s) => parseInt(s?.value))?.toString(),
      website: dataYup?.website,
      latitude: dataYup?.latitude,
      longitude: dataYup?.longitude,
      searchLatitude: dataYup?.searchLatitude,
      searchLongitude: dataYup?.searchLongitude,
      observation: dataYup?.observation,
      relatedMainOfficeId: relatedMainOffice?.value,
      relationType: mainOffice ? 'IS_MAIN' : 'IS_CHILD',
      spotting,
      fromArchive,
      relatedReportIds: selectedRepports?.length > 0 ? [selectedRepports] : null,
    };

    if (selectedEnterpriseP) {
      await postAxiosData(data);
    } else {
      let formdata = new FormData();
      if (dataYup?.files && dataYup?.files.length > 0) {
        Array.from(dataYup?.files)?.forEach((file) => {
          formdata.append('images', file);
        });
      }
      for (const key in data) {
        if (
          data.hasOwnProperty(key) &&
          key !== 'files' &&
          data[key] !== null &&
          data[key] !== undefined
        ) {
          formdata.append(key, data[key]);
        }
      }
      await postAxiosData(formdata);
    }
  };

  useEffect(() => {
    errorMassage?.message && setCanEdit(true);
  }, [errorMassage]);

  useEffect(() => {
    if (successMessage?.status === 200 || successMessage?.status === 201) {
      handleCloseInside();
      get();
      toast.success(successMessage?.message || t('toast_success_add'), {
        duration: 4000,
        className: 'bg-success text-white',
      });
    }
  }, [successMessage]);

  useEffect(() => {
    if (selectedEnterprise) {
      setCanEdit(false);
      setValue('socialRaison', selectedEnterprise?.socialRaison?.toUpperCase() || undefined);
      setValue(
        'employersNumber',
        selectedEnterprise?.employersNumber || selectedEnterprise?.employersRealNumber || undefined
      );
      setValue('sigle', selectedEnterprise?.sigle?.toUpperCase() || undefined);
      setValue('locality', selectedEnterprise?.locality || undefined);
      setValue('street', selectedEnterprise?.street || undefined);
      setValue('nui', selectedEnterprise?.nui || undefined);
      setValue('email', selectedEnterprise?.email || undefined);
      setValue('phone', selectedEnterprise?.phone || undefined);
      setValue('RHName', selectedEnterprise?.rhname || undefined);
      setValue('RHEmail', selectedEnterprise?.rhemail || undefined);
      setValue('RHPhone', selectedEnterprise?.rhphone || undefined);
      setValue('RHPhoneWh', selectedEnterprise?.rhphonewh || undefined);
      setValue('postal', selectedEnterprise?.postal || undefined);
      setValue('website', selectedEnterprise?.website || undefined);
      setValue('latitude', selectedEnterprise?.latitude || undefined);
      setValue('longitude', selectedEnterprise?.longitude || undefined);
      setValue('searchLatitude', selectedEnterprise?.searchLatitude || undefined);
      setValue('searchLongitude', selectedEnterprise?.searchLongitude || undefined);
      setValue('observation', selectedEnterprise?.observation || undefined);
      setRegion(selectedEnterprise?.region?.id);
      setDepartement(selectedEnterprise?.department?.id);
      setArrondissement(selectedEnterprise?.arrondissement?.id);
      setZone(selectedEnterprise?.zone?.id);
      setSpotting(selectedEnterprise?.spotting);
      setMainOffice(
        selectedEnterprise?.relationType == 'IS_MAIN' ||
          selectedEnterprise?.relationType == null ||
          selectedEnterprise?.relationType == undefined
      );
      setFromArchive(selectedEnterprise?.fromArchive);
      setrelatedMainOffice(
        selectedEnterprise?.relatedMainOffice
          ? {
              value: selectedEnterprise?.relatedMainOffice?.id,
              label: selectedEnterprise?.relatedMainOffice?.socialRaison,
            }
          : null
      );
      setSector(
        selectedEnterprise?.activitySectors?.map((a) => {
          return { value: a?.id, label: a?.name };
        })
      );
      setSelectedRepports(selectedEnterprise?.relatedReportIds?.map((r) => r.id));
    } else {
      setCanEdit(true);
      handleReset();
    }
  }, [selectedEnterprise]);

  const handleReset = () => {
    setRegion(null);
    setDepartement(null);
    setArrondissement(null);
    setZone(null);
    setSector([]);
    setrelatedMainOffice(null);
    reset();
  };

  const [openList, setOpenList] = useState(false);

  const handleCloseInside = () => {
    if (handleCloseOnly) {
      handleCloseOnly();
    } else {
      handleReset();
      handleClose();
      setSelectedEnterprise(null);
      setFromArchive(false);
      setSpotting(false);
      setCanEdit(true);
    }
  };

  const [loadingC, postAxiosChange, errorMassageC, successMessageC, resultC] = usePostAxiosData(
    `enterprises/${selectedEnterprise?.id}/change-status`,
    'PUT'
  );

  const changeStatus = (status) => {
    window.confirm(ENTERPRISE_STATUS[status]?.alert) &&
      postAxiosChange({ enterpriseStatus: status, userId: auth()?.user?.id });
  };

  useEffect(() => {
    if (successMessageC?.status === 200 || successMessageC?.status === 201) {
      handleClose();
      get();
      toast.success(successMessageC?.message || t('toast_success_status'), {
        duration: 4000,
        className: 'bg-success text-white',
      });
    }
  }, [successMessageC]);

  const [activityName, setActivityName] = useState('');
  const [loadingSec, createSector, errorMassageO, successMessageO, createdOccupation] =
    usePostAxiosData(`activity-sectors`, 'POST');

  const handleAddSector = () => {
    activityName &&
      window.confirm(t('confirm_add_sector', { name: activityName })) &&
      createSector({ name: activityName, creatorId: auth()?.user?.id });
  };

  useEffect(() => {
    if (successMessageO?.status === 200 || successMessageO?.status === 201) {
      fetchDataS();
      toast.success(successMessageO?.message || t('toast_success_sector'), {
        duration: 4000,
        className: 'bg-success text-white',
      });
    }
  }, [successMessageO]);

  const Related = () => {
    return (
      relateds?.data?.length > 0 && (
        <MuiCollapse
          title={t('collapse_links', { count: relateds?.data?.length || 0 })}
          bgColor={'rgba(1,0,15,0.1)'}
        >
          <List>
            {relateds?.data?.map((m) => (
              <ListItem
                disablePadding
                divider
                color={m?.relationType == 'IS_MAIN' ? 'green' : 'red'}
              >
                <ListItemButton>
                  <ListItemText
                    primary={`${m?.relationType == 'IS_MAIN' ? '--[Maison Mere]' : ''}--${m?.socialRaison}--${m?.region?.name}--${m?.department?.name}--${m?.arrondissement?.name}--${m?.street}`}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </MuiCollapse>
      )
    );
  };

  return (
    <React.Fragment>
      {loadingC && loadingEN && <PreloaderSpinner />}
      <EmployesByEnterpriseModal
        Fullscreen={true}
        title={'titre 1'}
        open={openList}
        setOpen={setOpenList}
        handleClose={() => setOpenList(false)}
        selectedEnterprise={selectedEnterprise}
      />
      <AssignEnterpriseToMission
        isOpen={openAss}
        onClose={() => setOpenAss(false)}
        selectedEnterprise={selectedEnterprise}
      />
      <AssignEnterpriseTotask
        isOpen={openAssTask}
        onClose={() => setOpenAsstask(false)}
        selectedEnterprise={selectedEnterprise}
      />
      <MergeEnterprises
        isOpen={openMerge}
        onClose={() => setOpenMerge(false)}
        selectedEnterprise={selectedEnterprise}
      />
      <Notify
        isOpen={openNotify}
        onClose={() => setOpenNotify(false)}
        selectedEnterprise={selectedEnterprise}
      />
      <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        onClose={handleCloseInside}
        aria-labelledby="customized-dialog-title"
        open={open}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar
            className={
              selectedEnterprise?.status == ENTERPRISE_STATUS.CLOSED.value
                ? 'bg-yellow-200'
                : selectedEnterprise?.status == ENTERPRISE_STATUS.DELETED.value
                  ? 'bg-red-300'
                  : 'bg-gray-50'
            }
          >
            <Typography
              sx={{ ml: 2, flex: 1 }}
              color={'green'}
              fontWeight={'bold'}
              variant="h6"
              component="div"
            >
              {selectedEnterprise || selectedEnterpriseP
                ? t(!canEdit || selectedEnterpriseP ? 'dialog_title_view' : 'dialog_title_edit')
                : loadingEN
                  ? '--'
                  : t('dialog_title_new')}
              {(selectedEnterprise?.socialRaison || selectedEnterpriseP?.socialRaison) && (
                <span className="text-center text-dark">
                  {`:${selectedEnterprise?.sigle || selectedEnterpriseP?.socialRaison ? '(' + (selectedEnterprise?.sigle || selectedEnterpriseP?.socialRaison) + ')' : ''} ${selectedEnterprise?.socialRaison}`}
                </span>
              )}
            </Typography>
            <div className="flex justify-end gap-2 pr-10">
              {selectedEnterprise && (
                <Tooltip
                  hasArrow
                  label={t('tooltip_view_expatriates')}
                  bg="green.200"
                  color="black"
                  placement="bottom"
                >
                  <button
                    className={`flex items-center gap-2 rounded-md p-1 shadow bg-white`}
                    onClick={() => setOpenList(true)}
                  >
                    <BsPeople size={30} className="text-green-500" />
                  </button>
                </Tooltip>
              )}
              {selectedEnterprise && (
                <Tooltip
                  hasArrow
                  label={t(canEdit ? 'tooltip_lock' : 'tooltip_edit')}
                  bg="green.200"
                  color="black"
                  placement="bottom"
                >
                  <button
                    className={`flex items-center gap-2 rounded-md p-1 shadow bg-white`}
                    onClick={() => setCanEdit(!canEdit)}
                  >
                    {canEdit ? (
                      <BsBan size={25} className="text-green-500" />
                    ) : (
                      <BsPencilSquare size={25} className="text-blue-500" />
                    )}
                  </button>
                </Tooltip>
              )}
              {selectedEnterprise && (
                <Tooltip
                  hasArrow
                  label={t(
                    selectedEnterprise?.latitude && selectedEnterprise?.longitude
                      ? 'tooltip_view_on_map'
                      : 'tooltip_search_on_map'
                  )}
                  bg="green.200"
                  color="black"
                  placement="bottom"
                >
                  <button
                    className={`flex items-center gap-2 rounded-md p-1 shadow bg-white`}
                    onClick={() => {
                      selectedEnterprise?.latitude && selectedEnterprise?.longitude
                        ? window.open(
                            createMapLink(
                              `${selectedEnterprise?.latitude},${selectedEnterprise?.longitude}`
                            ),
                            '_blank',
                            'noopener,noreferrer'
                          )
                        : selectedEnterprise?.searchLatitude && selectedEnterprise?.searchLongitude
                          ? window.open(
                              createMapLink(
                                `${selectedEnterprise?.searchLatitude},${selectedEnterprise?.searchLongitude}`
                              ),
                              '_blank',
                              'noopener,noreferrer'
                            )
                          : window.open(
                              createMapLink(
                                `${selectedEnterprise?.socialRaison} ${selectedEnterprise?.sigle} ${selectedEnterprise?.street} CAMEROON`
                              ),
                              '_blank',
                              'noopener,noreferrer'
                            );
                    }}
                  >
                    {(selectedEnterprise?.latitude && selectedEnterprise?.longitude) ||
                    (selectedEnterprise?.searchLatitude && selectedEnterprise?.searchLongitude) ? (
                      <BsGeoAlt size={25} className="text-green-500" />
                    ) : (
                      <BsSearch size={25} className="text-gray-500" />
                    )}
                  </button>
                </Tooltip>
              )}
              {selectedEnterprise && (
                <Tooltip
                  hasArrow
                  label={t('tooltip_assign_mission')}
                  bg="green.200"
                  color="black"
                  placement="bottom"
                >
                  <button
                    className={`flex items-center gap-2 rounded-md p-1 shadow bg-white`}
                    onClick={() => setOpenAss(true)}
                  >
                    <BsCarFront size={25} className="text-green-500" />
                  </button>
                </Tooltip>
              )}
              {selectedEnterprise && (
                <CheckAuthorization roles={[ROLES_LIST.ADMIN, ROLES_LIST.QUALITY]}>
                  <Tooltip
                    hasArrow
                    label={t('tooltip_assign_task')}
                    bg="green.200"
                    color="black"
                    placement="bottom"
                  >
                    <button
                      className={`flex items-center gap-2 rounded-md p-1 shadow bg-white`}
                      onClick={() => setOpenAsstask(true)}
                    >
                      <BsListTask size={25} className="text-green-500" />
                    </button>
                  </Tooltip>
                </CheckAuthorization>
              )}
              {selectedEnterprise && (
                <CheckAuthorization roles={[ROLES_LIST.ADMIN, ROLES_LIST.QUALITY]}>
                  <Tooltip
                    hasArrow
                    label={t('tooltip_merge')}
                    bg="green.200"
                    color="black"
                    placement="bottom"
                  >
                    <button
                      className={`flex items-center gap-2 rounded-md p-1 shadow bg-white`}
                      onClick={() => setOpenMerge(true)}
                    >
                      <BsIntersect size={25} className="text-green-500" />
                    </button>
                  </Tooltip>
                </CheckAuthorization>
              )}
              {selectedEnterprise && (
                <CheckAuthorization roles={[ROLES_LIST.ADMIN, ROLES_LIST.QUALITY]}>
                  <Tooltip
                    hasArrow
                    label={t('tooltip_notify')}
                    bg="red.200"
                    color="black"
                    placement="bottom"
                  >
                    <button
                      className={`flex items-center gap-2 rounded-md p-1 shadow bg-white`}
                      onClick={() => setOpenNotify(true)}
                    >
                      <BsEnvelopeExclamation size={25} className="text-red-500" />
                    </button>
                  </Tooltip>
                </CheckAuthorization>
              )}
              {selectedEnterprise && (
                <CheckAuthorization roles={[ROLES_LIST.ADMIN, ROLES_LIST.QUALITY]}>
                  <MMenus
                    options={[
                      {
                        icon: <BlindsClosed color="Warning" />,
                        label: t('menu_closed'),
                        handleClick: () => changeStatus('CLOSED'),
                      },
                      {
                        icon: <DeleteForeverSharp color="danger" />,
                        label: t('menu_delete'),
                        handleClick: () => changeStatus('DELETED'),
                      },
                      selectedEnterprise?.status != ENTERPRISE_STATUS.CREATED.value && {
                        icon: <RestorePageRounded color="action" />,
                        label: t('menu_restore'),
                        handleClick: () => changeStatus('CREATED'),
                      },
                    ].filter(Boolean)}
                  />
                </CheckAuthorization>
              )}
            </div>
            <CloseModalButton iconColor={'red'} handleClose={handleCloseInside} />
          </Toolbar>
        </AppBar>
        {loadingEN ? (
          <FormSkeleton />
        ) : (
          <DialogContent dividers>
            {selectedEnterpriseP && !selectedEnterprise ? (
              <Alert
                className="mb-5 rounded-lg shadow"
                status={
                  ENTERPRISE_STATUS.CLOSED.value == selectedEnterprise?.status ? 'warning' : 'error'
                }
              >
                <AlertIcon />
                <AlertTitle>{t('alert_not_found')}</AlertTitle>
              </Alert>
            ) : (
              <form onSubmit={handleSubmit(onSubmitHandler)}>
                {errorMassage?.message && <Error message={errorMassage?.message} />}
                {(selectedEnterprise?.status == ENTERPRISE_STATUS.CLOSED.value ||
                  selectedEnterprise?.status == ENTERPRISE_STATUS.DELETED.value) && (
                  <Alert
                    className="mb-5 rounded-lg shadow"
                    status={
                      ENTERPRISE_STATUS.CLOSED.value == selectedEnterprise?.status
                        ? 'warning'
                        : 'error'
                    }
                  >
                    <AlertIcon />
                    <AlertTitle>
                      {t(
                        ENTERPRISE_STATUS.CLOSED.value == selectedEnterprise?.status
                          ? 'alert_closed'
                          : 'alert_deleted'
                      )}
                    </AlertTitle>
                  </Alert>
                )}
                {selectedEnterprise?.fromArchive == true ? (
                  selectedEnterprise?.searchLatitude || selectedEnterprise?.searchLongitude ? (
                    <Alert className="mb-5 rounded-lg shadow" status="warning">
                      <AlertIcon />
                      <AlertTitle>{t('alert_not_visited_but_geo')}</AlertTitle>
                    </Alert>
                  ) : (
                    <Alert className="mb-5 rounded-lg shadow" status="error">
                      <AlertIcon />
                      <AlertTitle>{t('alert_not_visited')}</AlertTitle>
                    </Alert>
                  )
                ) : selectedEnterprise?.latitude || selectedEnterprise?.longitude ? (
                  <Alert className="mb-5 rounded-lg shadow" status="success">
                    <AlertIcon />
                    <AlertTitle>{t('alert_visited_and_geolocated')}</AlertTitle>
                  </Alert>
                ) : (
                  selectedEnterprise && (
                    <Alert className="mb-5 rounded-lg shadow" status="error">
                      <AlertIcon />
                      <AlertTitle>{t('alert_gps_error')}</AlertTitle>
                    </Alert>
                  )
                )}
                {selectedEnterprise?.spotting && (
                  <Alert className="mb-5 rounded-lg shadow" status={'warning'}>
                    <AlertIcon />
                    <AlertTitle>{t('alert_spotting_mode')}</AlertTitle>
                  </Alert>
                )}
                <div className="mb-4">
                  <div className="flex justify-center">
                    <FormControlLabel
                      onChange={(e) => setSpotting(e?.target?.checked)}
                      control={<Switch disabled={!canEdit} checked={spotting} color="success" />}
                      labelPlacement="start"
                      label={t('switch_spotting')}
                    />
                    <FormControlLabel
                      onChange={(e) => setFromArchive(e?.target?.checked)}
                      control={<Switch disabled={!canEdit} checked={fromArchive} color="success" />}
                      labelPlacement="start"
                      label={t('switch_from_archive')}
                    />
                  </div>
                  <div className="grid gap-2 md:grid-cols-2 justify-between py-1 border bg-gray-100 shadow">
                    <FormControlLabel
                      onChange={(e) => setMainOffice(e?.target?.checked)}
                      control={<Switch disabled={!canEdit} checked={mainOffice} color="success" />}
                      labelPlacement="start"
                      label={t('switch_main_office')}
                    />
                    {!mainOffice && (
                      <MuiAsyncAutocomplete
                        error={!relatedMainOffice}
                        fullWidth
                        disabled={!canEdit}
                        label={t('field_main_office')}
                        value={relatedMainOffice}
                        format={{ value: 'id', label: 'socialRaison' }}
                        fetch={'enterprises/search-all-by-term'}
                        handleChange={(e, item) => setrelatedMainOffice(item)}
                        wrapperClasses={'flex-1 filter-item anime slideRight'}
                      />
                    )}
                  </div>
                  <Related />
                  <div className="my-4 grid gap-2 md:grid-cols-2">
                    <div>
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('field_social_reason')}
                        id="socialRaison"
                        name="socialRaison"
                        type="text"
                        error={errors.socialRaison?.message}
                      />
                    </div>
                    <div>
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('field_sigle')}
                        id="sigle"
                        name="sigle"
                        type="text"
                        error={errors.sigle?.message}
                      />
                    </div>
                    <div>
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('field_niu')}
                        id="nui"
                        name="nui"
                        type="text"
                        error={errors.nui?.message}
                      />
                    </div>
                    <div>
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('field_company_email')}
                        id="email"
                        name="email"
                        type="text"
                        error={errors.email?.message}
                      />
                    </div>
                    <div>
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('field_company_phone')}
                        id="phone"
                        name="phone"
                        type="text"
                        error={errors.phone?.message}
                      />
                    </div>
                    <div>
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('field_expatriates_number')}
                        min="0"
                        id="employersNumber"
                        name="employersNumber"
                        type="number"
                        error={errors.employersNumber?.message}
                      />
                    </div>
                    <MuiAUtocomplete
                      //id="activitySectors"
                      disabled={!canEdit || sector?.length > 4}
                      multiple={true}
                      value={sector}
                      label={t('field_activity_sector')}
                      options={sectors?.data?.sort((a, b) => (a?.name > b?.name ? 1 : -1))}
                      format={{ value: 'id', label: 'name' }}
                      onChange={(event, items) => setSector(items)}
                      wrapperClasses={'flex-1 filter-item anime slideRight'}
                      inputValue={activityName}
                      onInputChange={(event, newInputValue) => setActivityName(newInputValue)}
                      handleNoOption={
                        <MButton onClick={handleAddSector}>{t('button_add_sector')}</MButton>
                      }
                      // textFieldProps={{
                      //   inputProps: { "data-testid": "sector-select" },
                      // }}
                    />
                  </div>
                  <div>
                    <div>
                      <h2 className="font-bold text-green-500">{t('section_address')}</h2>
                      <hr />
                    </div>
                    <div className="my-4 grid gap-2 md:grid-cols-2">
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_postal')}
                          id="postal"
                          name="postal"
                          type="text"
                          error={errors.postal?.message}
                        />
                      </div>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_street')}
                          id="street"
                          name="street"
                          type="text"
                          error={errors.street?.message}
                        />
                      </div>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_locality')}
                          id="locality"
                          name="locality"
                          type="text"
                          error={errors.locality?.message}
                        />
                      </div>
                      <MuiSelect
                        disabled={!canEdit}
                        label={t('field_region')}
                        value={region}
                        options={regions.data}
                        format={{ value: 'id', label: 'name' }}
                        onChange={(event) => setRegion(event.target.value)}
                        emptyLabel={'Aucun'}
                      />
                      <MuiSelect
                        disabled={!canEdit}
                        label={t('field_department')}
                        value={departement}
                        options={departments.data}
                        format={{ value: 'id', label: 'name' }}
                        onChange={(event) => setDepartement(event.target.value)}
                        emptyLabel={'Aucun'}
                      />
                      <MuiSelect
                        disabled={!canEdit}
                        label={t('field_arrondissement')}
                        value={arrondissement}
                        options={arrondissements.data}
                        format={{ value: 'id', label: 'name' }}
                        onChange={(event) => setArrondissement(event.target.value)}
                        emptyLabel={'Aucun'}
                      />
                      <MuiSelect
                        disabled={!canEdit}
                        label={t('field_zone')}
                        value={zone}
                        options={zones?.data?.map((z) => ({
                          value: z?.id,
                          label: `Zone ${z?.number} ${z?.description ? '--' + z?.description : ''}`,
                        }))}
                        onChange={(event) => setZone(event.target.value)}
                        emptyLabel={'Aucun'}
                      />
                      <MuiSelect
                        disabled={!canEdit}
                        label={t('field_report')}
                        value={selectedRepports}
                        options={repports?.data?.content?.map((z) => ({
                          value: z?.id,
                          label: `${z?.title} du ${formatDate(z?.date)}`,
                        }))}
                        onChange={(event) => setSelectedRepports(event.target.value)}
                        emptyLabel={'Aucun'}
                      />
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_website')}
                          id="website"
                          name="website"
                          type="text"
                          error={errors.website?.message}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <h2 className="font-bold text-green-500">{t('section_hr')}</h2>
                      <hr />
                    </div>
                    <div className="my-4 grid gap-2 md:grid-cols-2">
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_rh_name')}
                          id="RHName"
                          name="RHName"
                          type="text"
                          error={errors.RHName?.message}
                        />
                      </div>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_rh_email')}
                          id="RHEmail"
                          name="RHEmail"
                          type="text"
                          error={errors.RHEmail?.message}
                        />
                      </div>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_rh_phone')}
                          id="RHPhone"
                          name="RHPhone"
                          type="text"
                          error={errors.RHPhone?.message}
                        />
                      </div>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_rh_whatsapp')}
                          id="RHPhoneWh"
                          name="RHPhoneWh"
                          type="text"
                          error={errors.RHPhoneWh?.message}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <h2 className="font-bold text-green-500">{t('section_positions')}</h2>
                      <hr />
                    </div>
                    <div className="my-4 grid gap-2 md:grid-cols-2">
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_latitude')}
                          id="latitude"
                          name="latitude"
                          type="text"
                          error={errors.latitude?.message}
                        />
                      </div>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_longitude')}
                          id="longitude"
                          name="longitude"
                          type="text"
                          error={errors.longitude?.message}
                        />
                      </div>
                      <h2 className="font-bold text-green-500">{t('section_google_map')}</h2>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_search_latitude')}
                          id="searchLatitude"
                          name="searchLatitude"
                          type="text"
                          error={errors.searchLatitude?.message}
                        />
                      </div>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_search_longitude')}
                          id="searchLongitude"
                          name="searchLongitude"
                          type="text"
                          error={errors.searchLongitude?.message}
                        />
                      </div>
                      <div>
                        <InputField
                          disabled={!canEdit}
                          multiline={true}
                          register={register}
                          variant="auth"
                          extra="mb-3"
                          label={t('field_observation')}
                          id="observation"
                          name="observation"
                          type="text"
                          error={errors.observation?.message}
                        />
                      </div>
                    </div>
                  </div>
                  {canEdit && !selectedEnterpriseP && (
                    <div className="flex flex-col items-center justify-center gap-4 w-full bg-orange-50 p-4 rounded-md shadow-md">
                      <label
                        htmlFor="file-upload"
                        className="cursor-pointer flex flex-col items-center justify-center border-2 border-dashed border-green-300 rounded-lg p-6 hover:bg-green-400 hover:border-white text:gray-400 hover:text-white transition duration-300"
                      >
                        <svg
                          className="w-10 h-10 mb-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M7 16V8m0 0l-4 4m4-4l4 4m5 4v-4m0 0l4 4m-4-4l-4 4"
                          ></path>
                        </svg>
                        <span className="text-sm">{t('label_upload_file')}</span>
                        <span className="text-xs">{t('label_accepted_formats')}</span>
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        name="files"
                        {...register('files')}
                        aria-describedby="file-input-help"
                        multiple
                        accept=".jpg, .jpeg, .png, .pdf"
                      />
                      {errors?.files?.message && (
                        <p className="text-sm text-red-500 mt-2">{errors.files.message}</p>
                      )}
                    </div>
                  )}
                  {selectedEnterprise?.images?.length > 0 && (
                    <>
                      <h2 className="font-bold text-green-500">{t('section_files')}</h2>
                      {selectedEnterprise?.images?.filter(
                        (i) => i?.fileName?.split('.').pop()?.toLowerCase() !== 'pdf'
                      ).length > 0 && (
                        <MuiCollapse
                          title={t('collapse_images', {
                            count:
                              selectedEnterprise?.images?.filter(
                                (i) => i?.fileName?.split('.').pop()?.toLowerCase() !== 'pdf'
                              ).length || 0,
                          })}
                          bgColor={'rgba(0,150,0,0.1)'}
                        >
                          <ImageGallery
                            images={selectedEnterprise?.images
                              ?.filter(
                                (i) => i?.fileName?.split('.').pop()?.toLowerCase() !== 'pdf'
                              )
                              ?.map((img) => ({
                                original: getImageUrlAPI(img?.fileName),
                                thumbnail: getImageUrlAPI(img?.fileName),
                              }))}
                          />
                        </MuiCollapse>
                      )}
                      {selectedEnterprise?.images?.filter(
                        (i) => i?.fileName?.split('.').pop()?.toLowerCase() === 'pdf'
                      ).length > 0 && (
                        <MuiCollapse
                          title={t('collapse_pdfs', {
                            count:
                              selectedEnterprise?.images?.filter(
                                (i) => i?.fileName?.split('.').pop()?.toLowerCase() === 'pdf'
                              ).length || 0,
                          })}
                          bgColor={'rgba(0,150,0,0.1)'}
                        >
                          {selectedEnterprise?.images
                            ?.filter((i) => i?.fileName?.split('.').pop()?.toLowerCase() === 'pdf')
                            ?.map((pdf, index) => (
                              <PDFViewer key={index} fileName={pdf?.fileName} />
                            ))}
                        </MuiCollapse>
                      )}
                    </>
                  )}
                </div>
                {selectedEnterprise && (
                  <Badge>
                    {t('badge_collected_by')}{' '}
                    {selectedEnterprise?.creator
                      ? ` ${selectedEnterprise?.creator?.firstName} ${selectedEnterprise?.creator?.lastName}`
                      : '--'}
                  </Badge>
                )}
                {selectedEnterprise && (
                  <Badge
                    color={'black'}
                    backgroundColor={'orange'}
                  >{` ${selectedEnterprise ? ` ${formatDateTime(selectedEnterprise?.createdAt)}` : '--'}`}</Badge>
                )}
                {selectedEnterprise && (
                  <MuiCollapse
                    title={t('collapse_history', { count: modifications?.data?.length || 0 })}
                    bgColor={'rgba(150,0,0,0.1)'}
                  >
                    <List>
                      {modifications?.data
                        ?.sort((a, b) => a?.editedAt < b?.editedAt)
                        ?.map((m) => (
                          <ListItem disablePadding divider>
                            <ListItemButton>
                              <ListItemText
                                primary={`${m?.editedBy?.firstName || ''} ${m?.editedBy?.lastName || ''} --${formatDateTime(m?.editedAt)}`}
                                secondary={m?.description}
                              />
                            </ListItemButton>
                          </ListItem>
                        ))}
                    </List>
                  </MuiCollapse>
                )}
                <DialogActions className="flex justify-between">
                  <Button variant={'danger'} className="btn-danger" onClick={handleCloseInside}>
                    {t('button_close')}
                  </Button>
                  {((selectedEnterprise && canEdit) || !selectedEnterprise) && (
                    <Button type="submit" colorScheme="green" isLoading={loading}>
                      {t(selectedEnterprise ? 'button_update' : 'button_save')}
                    </Button>
                  )}
                </DialogActions>
              </form>
            )}
          </DialogContent>
        )}
      </Dialog>
    </React.Fragment>
  );
}
